import { render, staticRenderFns } from "./cookieConsent.vue?vue&type=template&id=19cf47c0&"
import script from "./cookieConsent.vue?vue&type=script&lang=js&"
export * from "./cookieConsent.vue?vue&type=script&lang=js&"
import style0 from "./cookieConsent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports